import App from "./App";
import React from "react";
import get from "lodash/get";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import * as analytics from "@analytics";
import configureStore from "./configureStore";
import clock from "./clock";
import config from "@config";
import { onbeforeunload } from "./windowEvents";
import moment from "moment";
import feathersApp from "./feathers";
import { markPendingOnboardings } from "./constants/onboardings";
import {
  parseOAuthHash,
  clearOAuthHash,
} from "./utils/oauthHash";

// import reportWebVitals from './reportWebVitals';

// Added this global for DatePicker
// https://ant.design/components/date-picker/#Localization
moment.locale("es");

const { store, initialDispatch } = configureStore(undefined, { initialDispatch: false });

// Capturar token de OAuth desde el hash de la URL (cuando vuelve de Google/Facebook)
const handleOAuthCallback = async () => {
  const oauthResult = parseOAuthHash();
  if (!oauthResult) {
    return false;
  }

  clearOAuthHash();

  if (oauthResult.error) {
    store.dispatch({ type: 'AUTH_OAUTH_ERROR' });
    return false;
  }

  const { accessToken } = oauthResult;
  if (!accessToken) {
    return false;
  }

  try {
    await feathersApp.authentication.setAccessToken(accessToken);
    const result = await feathersApp.authentication.reAuthenticate(true);

    if (result.accessToken) {
      markPendingOnboardings(result.user?._id);
      store.dispatch({ type: 'AUTH_SET_TOKEN', payload: result.accessToken });
      store.dispatch({ type: 'AUTH_SET_USER', payload: result.user });
      analytics.set({ userId: result.user._id });
      return true;
    }
  } catch (error) {
    console.error('Error procesando token de OAuth:', error);
    store.dispatch({ type: 'AUTH_OAUTH_ERROR' });
  }

  return false;
};

const bootstrap = async () => {
  // Esperar OAuth antes de montar React: evita que loginThunk corra sin sesión.
  await handleOAuthCallback();
  if (typeof initialDispatch === "function") {
    initialDispatch();
  }

  analytics.start();
  analytics.pageview(get(store.getState(), "location.pathname"));

  window.onbeforeunload = onbeforeunload(store);

  clock.set({ store });
  clock.startAppResetTime(config.clockTickTimeMS);

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
};

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
